import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const getAllParts = async (
  organisationID = "",
  searchName = "",
  page = 1,
  pageSize = 99999,
  partType = [],
  status = [],
  assets = [],
  vendors = [],
  locations = [],
  area = [],
  teams = [],
  category = [],
  serialNumber,
  sort = [],
  role,
  allIds
) => {
  let assetFilters = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },

    inventory: {
      location: {
        id: {
          $in: locations,
        },
      },
    },
    assets: {
      id: {
        $in: assets,
      },
    },
    vendors: {
      id: {
        $in: vendors,
      },
    },
    teams: {
      id: {
        $in: teams,
      },
    },
    category: {
      id: {
        $in: category,
      },
    },
  };

  if (locations?.length == 0 && role !== "super_admin") {
    assetFilters.inventory = {
      location: {
        id: {
          $in: allIds,
        },
      },
    };
  } else {
    assetFilters.inventory = {
      location: {
        id: {
          $in: locations,
        },
      },
    };
  }

  if (status.length > 0 && status[0] !== "") {
    assetFilters.status = {
      $eq: status[0],
    };
  }

  if (partType && partType[0] !== "") {
    assetFilters.type = {
      $eq: partType[0],
    };
  }

  if (serialNumber) {
    assetFilters.serialNumber = {
      $eq: serialNumber,
    };
  }

  if (locations.length > 0 && area.length == 0) {
    assetFilters.inventory = {
      location: {
        id: {
          $in: locations,
        },
      },
    };
  } else if (locations.length > 0 && area.length > 0) {
    assetFilters.inventory = {
      $and: [
        {
          location: {
            id: {
              $in: locations,
            },
          },
        },
        {
          area: {
            id: {
              $in: area,
            },
          },
        },
      ],
    };
  }

  const queryParams = {
    sort: sort.length > 0 ? sort : ["countNumId:desc"],
    filters: assetFilters,
    _q: searchName,
    populate: [
      "image",
      "files",
      "assets",
      "location",
      "vendors",
      "customFields",
      "vendors.logo",
      "assets.image",
      "procedure",
      "createdByUser",
      "purchaseOrder",
      "category",
      "createdByUser.profileImage",
      "inventory",
      "inventory.location",
      "inventory.area",
      "people",
      "teams",
      "updatedByUser",
      "updatedByUser.profileImage",
      "logo",
      "sets",
    ],
  };

  if (page && pageSize) {
    queryParams["pagination[page]"] = String(page);
    queryParams["pagination[pageSize]"] = String(pageSize);
  }
  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `parts?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let dataObj = {
      response: response.data.data,
      status: response.status,
      pagination: response.data.meta.pagination,
    };

    return dataObj;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};
